<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="main-panel" *ngIf="esRolPostulante; else gestionPostulacionesTpl">
    <header class="topbar">
      <h1>Plataforma Unica de Postulacion</h1>
      <div class="topbar-right">
        <app-header-notification-bell [rol]="rol"></app-header-notification-bell>
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <app-inicio-concursos-panel [rolSeleccionado]="rol" [mostrarFiltrosPostulaciones]="true"></app-inicio-concursos-panel>
  </div>

  <ng-template #gestionPostulacionesTpl>
    <div class="main-panel">
      <header class="topbar">
        <h1>Postulaciones</h1>
        <div class="topbar-right">
          <app-header-notification-bell [rol]="rol"></app-header-notification-bell>
          <app-accessibility-toolbar></app-accessibility-toolbar>
          <app-user-session-summary></app-user-session-summary>
        </div>
      </header>
      <div class="content-breadcrumbs">
        <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
      </div>
      <app-postulaciones-panel [rol]="rol"></app-postulaciones-panel>
    </div>
  </ng-template>
</div>
